import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

const ChannelTypeSelector = ({
  selectedChannelOptions,
  onUpdateSelectedChannelType,
  channelTypeList,
}) => {
  const [currentChannelTypeList] = useState(channelTypeList);

  // Handler for updating selected channel types
  const onUpdateSelected = (newSelectedTypes) => {
    onUpdateSelectedChannelType(newSelectedTypes);
  };

  return (
    <>
      <Select
        isMulti
        isClearable={false}
        defaultValue={[]}
        options={currentChannelTypeList}
        onChange={onUpdateSelected}
        value={selectedChannelOptions}
        placeholder="All Channel Types"
        aria-label="select channel types"
      />
    </>
  );
};

ChannelTypeSelector.propTypes = {
  selectedChannelOptions: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.number, name: PropTypes.string }),
  ).isRequired,
  onUpdateSelectedChannelType: PropTypes.func.isRequired,
  channelTypeList: PropTypes.arrayOf(
    PropTypes.shape({ value: PropTypes.string, label: PropTypes.string }),
  ).isRequired,
};

export default ChannelTypeSelector;
